import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const CloseThickIcon = ({
    size = 16,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 11 10"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path d="m7.215 5 3.367-3.366a.5.5 0 0 0 0-.706L9.8.146a.5.5 0 0 0-.706 0L5.728 3.513 2.362.146a.5.5 0 0 0-.706 0L.874.928a.5.5 0 0 0 0 .706L4.24 5 .874 8.366a.5.5 0 0 0 0 .706l.782.782a.5.5 0 0 0 .706 0l3.366-3.366 3.366 3.366a.5.5 0 0 0 .706 0l.782-.782a.5.5 0 0 0 0-.706L7.215 5Z"/>
    </svg>
);
CloseThickIcon.displayName = 'CloseThickIcon';
export default CloseThickIcon;
